import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { ConfirmationModalInputParams } from 'src/app/model/confirmation-modal-input-param';

@Component({
    selector: 'confirmation-modal',
    templateUrl: './confirmation-modal.component.html',
    styleUrls: ['./confirmation-modal.component.scss']
})

export class ConfirmationModalComponent implements OnInit {
    @ViewChild('modalConfirm') modalConfirmRef: ElementRef<any> | undefined;
    private subject = new Subject<any>;
    public modalMessage: any;
    public modalText : string = ""; 
    public title : string = "Confirmation";
    public modalTitle : string = '';
    public primaryButtonText?: string;
    public hideSecondaryButton!: boolean;
    public secondayButtonText?: string;

    ngOnInit(): void {
        this.subject.subscribe(modalMessage => {this.modalMessage = modalMessage});        
    }

    public confirm(param : ConfirmationModalInputParams) {
        let that = this;
        this.modalText = param.msg;
        this.modalTitle = param.modalTitle ? param.modalTitle : this.title;
        this.subject.next({
            actionYes: function () {
                that.modalConfirmRef?.nativeElement.closeModal();
                param.yesFunc();
            },
            actionNo: function () {
                that.modalConfirmRef?.nativeElement.closeModal();
                if (param.noFunc != undefined) {
                    param.noFunc() 
                }
            }
        });
        if (param.buttonInfo !== undefined && param.buttonInfo.primaryText !== '') {
            this.primaryButtonText = param.buttonInfo?.primaryText;
        }
        else {
            this.primaryButtonText = 'Yes';
        }

        if (param.buttonInfo !== undefined && param.buttonInfo.hideSecondaryButton && param.buttonInfo.secondaryText !== (undefined || '')) {
            this.secondayButtonText = param.buttonInfo?.secondaryText;
        }
        else {
            this.secondayButtonText = 'No';
        }

        this.hideSecondaryButton = param.buttonInfo == undefined? false : param.buttonInfo?.hideSecondaryButton;
        this.modalConfirmRef?.nativeElement.openModal();
    }

    reset() {
        this.primaryButtonText = undefined;
        this.secondayButtonText = undefined;
        this.hideSecondaryButton = false;
    }
    
}
